<template>
  <p class="alert misInfo"> <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
    <img class="imght" src="../../assets/images/nodata.png" title="No Data Image" alt="No Data Image" /> The Data is
    Inadequate to load the Widget and Insights. Kindly give a Try Changing the Filter or Date Span
  </p>
</template>
<script>
export default {
  name: 'widgetDataMsg',
  props: {
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.imght {
  height: 100px;
}

.misInfo {
  font-weight: 300;
  background-image: linear-gradient(to right, rgb(218 189 189 / 0%), rgb(151 172 230 / 44%));
  box-shadow: rgba(18, 18, 18, 0.11) 0px 0px 0px 0px, rgba(18, 18, 18, 0.10) 0px 2px 2px 0px;
}
</style>
